export default {
  'diagram1-5d': {
    'structure-answers-title': `Elements of the problem definition`,
    'exercise-title': 'RISK MANAGEMENT STUDY – BENCHMARK ADVANTAGE - PROBLEM',
    'situation-title': 'situation',
    'diagram-header': 'Bank Credit Card Issuers',
    'bottom-box-points': `
      <ul>
        <li>
            Must deal with
            <ul>
                <li>Delinquences</li>
                <li>Charge-offs</li>
                <li>Bankruptcies</li>
                <li>Credit utilization</li>
            </ul>
        </li>
      </ul>
      <ul style="max-width: 187px">
        <li>
            Affected by changes in
            <ul>
                <li>Unemployment rates</li>
                <li>Debt to personal income ratios</li>
                <li>Other economic influencers of risk</li>
            </ul>
        </li>
      </ul>
      `,
    'situation-desc': `Attempt to manage portfolio risk in the face of economic change<br/> - Rely on benchmarking studies for insights`,
    'disturbing-event': 'DISTURBING EVENT'
  }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5d/diagram1/i18n/en.js